interface CharacterProps {
  characterId: string
  mood?: string
  size?: number
  color?: string
}

// Renders a character sprite. Missing images degrade to a colored initial placeholder.
export function Character({ characterId, mood = 'idle', size = 80, color = '#7c3aed' }: CharacterProps) {
  const src = `/sprites/algoquest/${characterId}/${mood}.png`
  const initial = characterId.charAt(0).toUpperCase()

  return (
    <div
      style={{ width: size, height: size, flexShrink: 0 }}
      className="relative rounded-full overflow-hidden"
    >
      <div
        className="absolute inset-0 flex items-center justify-center font-bold text-white text-xl"
        style={{ backgroundColor: color }}
      >
        {initial}
      </div>
      <img
        src={src}
        alt={characterId}
        className="absolute inset-0 w-full h-full object-cover"
        onError={(e) => {
          // Hide the broken image so the placeholder shows through
          ;(e.target as HTMLImageElement).style.display = 'none'
        }}
      />
    </div>
  )
}
